module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-7.7e12f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-7.jpg
// module id = i9HL
// module chunks = 1